import styled from '@emotion/styled';
import media from '@shared/mediaQuery';

const InquiryActionPopupStyle = styled('div')`
  background-color: #ffffff;
  border-radius: 4px;
  ${media.mobile} {
    width: calc(100% - 40px);
    padding-top: 21px;
    padding-bottom: 30px;
    margin: 95px auto;
  }
  ${media.desktop} {
    padding-top: 35px;
    padding-bottom: 100px;
    width: 400px;
    box-shadow: 5px 5px 20px 0 rgba(0, 0, 0, 0.1);
  }
  .closeButton {
    position: absolute;
    top: 24px;
    right: 24px;
  }
  .questionpopup {
    &--title {
      font-family: 'Pretendard-Bold';
      text-align: center;
      font-size: 24px;
      ${media.mobile} {
        margin-bottom: 3px;
      }
    }
    &--body {
      text-align: center;
      ${media.mobile} {
      }
      ${media.desktop} {
        margin: 8px auto 0;
      }
      &-text {
        -webkit-appearance: none;
        border-radius: 0;
        width: 295px;
        height: 92px;
        resize: none;
        padding: 9px 12px;
        line-height: 20px;
        font-size: 14px;
        border: solid 1px #cfcfcf;
        ${media.desktop} {
          height: 159px;
        }
        ${media.mobile} {
          width: calc(100% - 90px);
        }
        &::placeholder {
          font-family: 'Pretendard-Regular';
          font-size: 14px;
          color: #999999;
        }
        &:focus {
          outline: none;
          border: solid 1px #333333;
        }
        &.phone {
          height: 35px;
          line-height: 35px;
          padding: 0 12px;
          ${media.mobile} {
            height: 35px;
            line-height: 35px;
          }
        }
        &.name {
          height: 35px;
          line-height: 35px;
          padding: 0 12px;
          ${media.mobile} {
            height: 35px;
            line-height: 35px;
          }
        }
        &.office {
          height: 35px;
          line-height: 35px;
          padding: 0 12px;
          ${media.mobile} {
            height: 35px;
            line-height: 35px;
          }
        }
      }
      &-editor {
        ${media.mobile} {
          padding-top: 12px;
        }
        ${media.desktop} {
          padding-top: 15px;
        }
        &.phone {
          ${media.desktop} {
            padding-bottom: 5px;
          }
        }
      }
      &-header {
        display: flex;
        justify-content: space-between;
        &-title {
          font-size: 14px;
          color: #333333;
          font-family: 'Pretendard-Bold';
          ${media.desktop} {
            font-size: 16px;
          }
        }
        &-length {
          font-size: 12px;
          color: #aaaaaa;
        }
      }
      &-editor {
        border-top: none;
      }
    }
    &--individual {
      display: flex;
      margin-left: 2px;
      ${media.desktop} {
        margin-left: 20px;
        margin-top: 13px;
      }
      ${media.mobile} {
        margin-top: 10px;
      }
      .checkbox--label {
        font-size: 12px;
        margin-top: 0px;
      }
      &-wrap {
        padding: 0 21px;
        ${media.mobile} {
          padding: 0 30px;
        }
      }
      &-button {
        font-family: 'Pretendard-Bold';
        font-size: 12px;
        color: #757575;
        margin-left: 8px;
        margin-top: -4px;
        ${media.desktop} {
          margin-left: 9px;
        }
        ${media.mobile} {
          margin-top: -2px;
        }
      }
      &-table {
        display: flex;
        justify-content: space-between;
        background-color: #f6f6f6;
        margin-top: 10px;
        max-height: 0;
        overflow: hidden;
        transition: max-height 0.8s ease-out;
        ${media.desktop} {
          width: 318px;
          margin: 10px auto 0;
        }
        &.show {
          max-height: 500px;
          transition: max-height 0.8s ease-out;
          ${media.mobile} {
            margin-bottom: 20px;
          }
        }
        &-column {
          border-left: solid 1px #ffffff;
          ${media.mobile} {
            min-width: 33.33%;
          }
          ${media.desktop} {
            width: 193px;
          }
        }
        &-header {
          text-align: center;
          background-color: #e0e0e0;
          font-size: 11px;
          color: #757575;
          font-family: 'Pretendard-Bold';
          padding: 3px 0;
          ${media.desktop} {
            font-size: 12px;
          }
        }
        &-body {
          font-size: 11px;
          color: #999999;
          text-align: center;
          padding: 8px 1px;
          ${media.desktop} {
            padding: 7px 0;
            font-size: 12px;
          }
        }
      }
    }
    &--buttons {
      margin-top: 11px;
      ${media.desktop} {
        margin-top: 22px;
        float: right;
        margin-right: 40px;
      }
      ${media.mobile} {
        display: flex;
        width: calc(100% - 60px);
        margin: auto;
      }
    }
    &--button {
      font-family: 'Pretendard-Bold';
      font-size: 15px;
      height: 40px;
      ${media.desktop} {
        height: 48px;
      }
      ${media.mobile} {
        width: 50%;
        font-size: 14px;
      }

      &.delete {
        color: #757575;
        background-color: #f6f6f6;
      }
      &.complete {
        background-color: #ff5500;
        color: #ffffff;
        ${media.desktop} {
          width: 160px;
        }
      }
    }
  }
`;

export default InquiryActionPopupStyle;
